module.exports = __webpack_public_path__ + "img/cureline-logo-black.640e73d5.svg";